/**
 * Property Gallery
 *
 * @description: Interactive thumbnail scrolling for property gallery
 */
jQuery(function ($) {
    // Initialize drag functionality for all property gallery thumbnails when page loads
    $(".property-gallery__thumbnails").each(function () {
        initPropertyGalleryDrag($(this));
    });

    // Function to initialize drag functionality for property gallery thumbnails
    function initPropertyGalleryDrag($container) {
        if (!$container.length) return;

        // Check if container has scrollable content
        const hasScrollbar = $container[0].scrollWidth > $container[0].clientWidth;
        if (!hasScrollbar) {
            $container
                .removeClass("property-gallery__thumbnails--draggable")
                .addClass("property-gallery__thumbnails--no-draggable");
            return;
        }

        let isDragging = false;
        let hasDragged = false;
        let startX = 0;
        let scrollLeft = 0;
        let momentum = 0;
        let lastX = 0;
        let lastTime = 0;
        let animationId = null;

        // Remove any existing drag event listeners to avoid duplicates
        $container.off(".propertyThumbnailDrag");

        // Add smooth CSS transition for when not dragging
        $container.addClass("property-gallery__thumbnails--draggable").css({
            "scroll-behavior": "auto",
            transition: "none",
        });

        $container.on("mousedown.propertyThumbnailDrag", function (e) {
            // Only drag with left mouse button
            if (e.which !== 1) return;

            isDragging = true;
            hasDragged = false;
            startX = e.pageX;
            lastX = e.pageX;
            lastTime = Date.now();
            scrollLeft = $container.scrollLeft();
            momentum = 0;

            // Cancel any existing momentum animation
            if (animationId) {
                cancelAnimationFrame(animationId);
                animationId = null;
            }

            // Reset cursor and enable pointer events
            $container.find(".property-gallery__thumb-link").css({
                cursor: "grabbing",
                "user-select": "",
                "-webkit-user-select": "",
                "-moz-user-select": "",
                "-ms-user-select": "",
                "pointer-events": "",
            });

            // Prevent default behavior
            e.preventDefault();
        });

        $(document).on("mousemove.propertyThumbnailDrag", function (e) {
            if (!isDragging) return;

            const x = e.pageX;
            const distance = Math.abs(x - startX);
            const currentTime = Date.now();

            // If moved more than 3 pixels, consider it a drag
            if (distance > 3) {
                hasDragged = true;

                // Add cursor style and prevent text selection
                $container.find(".property-gallery__thumb-link").css({
                    cursor: "grabbing",
                    "user-select": "none",
                    "-webkit-user-select": "none",
                    "-moz-user-select": "none",
                    "-ms-user-select": "none",
                    "pointer-events": "none",
                });
            }

            if (hasDragged) {
                e.preventDefault();

                // Calculate momentum for smoother movement
                const deltaTime = currentTime - lastTime;
                if (deltaTime > 0) {
                    momentum = (x - lastX) / deltaTime;
                }

                const walk = (x - startX) * 1.2; // Multiplier for smooth movement
                const newScrollLeft = scrollLeft - walk;

                // Smooth scrolling with bounds checking
                const maxScroll = $container[0].scrollWidth - $container[0].clientWidth;
                const boundedScroll = Math.max(0, Math.min(maxScroll, newScrollLeft));

                // Use requestAnimationFrame for smoother scrolling
                if (animationId) {
                    cancelAnimationFrame(animationId);
                }

                animationId = requestAnimationFrame(function () {
                    $container.scrollLeft(boundedScroll);
                });

                lastX = x;
                lastTime = currentTime;
            }
        });

        // Function to apply momentum after drag ends
        function applyMomentum() {
            if (Math.abs(momentum) < 0.1) return;

            const currentScroll = $container.scrollLeft();
            const maxScroll = $container[0].scrollWidth - $container[0].clientWidth;

            // Calculate new scroll position with momentum
            const newScroll = currentScroll - momentum * 15; // Momentum factor
            const boundedScroll = Math.max(0, Math.min(maxScroll, newScroll));

            // Apply easing to momentum
            momentum *= 0.95;

            // Smooth scroll to new position
            animationId = requestAnimationFrame(function () {
                $container.scrollLeft(boundedScroll);

                // Continue momentum if still significant
                if (Math.abs(momentum) > 0.1) {
                    applyMomentum();
                }
            });
        }

        $(document).on("mouseup.propertyThumbnailDrag", function (e) {
            if (isDragging) {
                isDragging = false;

                // Apply momentum for smooth deceleration
                if (hasDragged && Math.abs(momentum) > 0.5) {
                    applyMomentum();
                }

                // Reset cursor and enable pointer events
                $container.find(".property-gallery__thumb-link").css({
                    cursor: "grab",
                    "user-select": "",
                    "-webkit-user-select": "",
                    "-moz-user-select": "",
                    "-ms-user-select": "",
                    "pointer-events": "",
                });
            }
        });

        // Handle mouse leave to stop dragging
        $container.on("mouseleave.propertyThumbnailDrag", function () {
            if (isDragging) {
                isDragging = false;

                // Apply momentum for smooth deceleration
                if (hasDragged && Math.abs(momentum) > 0.5) {
                    applyMomentum();
                }

                $container.find(".property-gallery__thumb-link").css({
                    cursor: "grab",
                    "user-select": "",
                    "-webkit-user-select": "",
                    "-moz-user-select": "",
                    "-ms-user-select": "",
                });
            }
        });

        // Add initial grab cursor when hovering over container
        $container.find(".property-gallery__thumb-link").css("cursor", "grab");
    }
});
